import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import HomePage from './pages/HomePage';
import OmniAgentPage from './pages/OmniAgentPage';
import TotalFarmPage from './pages/TotalFarmPage';
import FyntLoanPage from './pages/FyntLoanPage';
import SwiftGuardPage from './pages/SwiftGuardPage';
import TechIQBoxPage from './pages/TechIQBoxPage';
import SomoLearnPage from './pages/SomoLearnPage';
import AppDevelopmentPage from './pages/services/AppDevelopmentPage';
import WebDevelopmentPage from './pages/services/WebDevelopmentPage';
import BPOServicesPage from './pages/services/BPOServicesPage';
import AISolutionsPage from './pages/services/AISolutionsPage';
import CloudServicesPage from './pages/services/CloudServicesPage';
import OfferingsPage from './pages/OfferingsPage';

// Analytics tracker
import AnalyticsTracker from './components/AnalyticsTracker';

// Admin imports
import { AuthProvider } from './admin/context/AuthContext';
import ProtectedRoute from './admin/components/ProtectedRoute';
import LoginPage from './admin/pages/LoginPage';
import DashboardPage from './admin/pages/DashboardPage';
import PagesListPage from './admin/pages/PagesListPage';
import PageEditorPage from './admin/pages/PageEditorPage';
import AnalyticsPage from './admin/pages/AnalyticsPage';
import SEOPage from './admin/pages/SEOPage';
import SettingsPage from './admin/pages/SettingsPage';
import LeadsPage from './admin/pages/LeadsPage';
import RoundtablePage from './admin/pages/RoundtablePage';

// Hidden lead-capture pages (NOT in Header/Footer)
import BaRidePage from './pages/BaRidePage';
import Care365Page from './pages/Care365Page';
import ZambiaRoundtablePage from './pages/ZambiaRoundtablePage';
import SMEPartnershipPage from './pages/SMEPartnershipPage';
import SMEWorkspacePage from './pages/SMEWorkspacePage';

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <AuthProvider>
          <AnalyticsTracker />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/omniagent" element={<OmniAgentPage />} />
            <Route path="/totalfarm" element={<TotalFarmPage />} />
            <Route path="/fyntloan" element={<FyntLoanPage />} />
            <Route path="/swiftguard" element={<SwiftGuardPage />} />
            <Route path="/techiqbox" element={<TechIQBoxPage />} />
            <Route path="/somolearn" element={<SomoLearnPage />} />
            <Route path="/services/app-development" element={<AppDevelopmentPage />} />
            <Route path="/services/web-development" element={<WebDevelopmentPage />} />
            <Route path="/services/bpo" element={<BPOServicesPage />} />
            <Route path="/services/ai-solutions" element={<AISolutionsPage />} />
            <Route path="/services/cloud" element={<CloudServicesPage />} />
            <Route path="/offerings" element={<OfferingsPage />} />

            {/* Hidden Lead Capture Pages */}
            <Route path="/baride" element={<BaRidePage />} />
            <Route path="/care365" element={<Care365Page />} />
            <Route path="/zambia-roundtable" element={<ZambiaRoundtablePage />} />
            <Route path="/sme-partnership" element={<SMEPartnershipPage />} />
            <Route path="/sme-workspace" element={<SMEWorkspacePage />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<LoginPage />} />
            <Route path="/admin" element={
              <ProtectedRoute><DashboardPage /></ProtectedRoute>
            } />
            <Route path="/admin/pages" element={
              <ProtectedRoute><PagesListPage /></ProtectedRoute>
            } />
            <Route path="/admin/pages/:pageSlug" element={
              <ProtectedRoute><PageEditorPage /></ProtectedRoute>
            } />
            <Route path="/admin/analytics" element={
              <ProtectedRoute><AnalyticsPage /></ProtectedRoute>
            } />
            <Route path="/admin/seo" element={
              <ProtectedRoute><SEOPage /></ProtectedRoute>
            } />
            <Route path="/admin/settings" element={
              <ProtectedRoute><SettingsPage /></ProtectedRoute>
            } />
            <Route path="/admin/leads" element={
              <ProtectedRoute><LeadsPage /></ProtectedRoute>
            } />
            <Route path="/admin/roundtable" element={
              <ProtectedRoute><RoundtablePage /></ProtectedRoute>
            } />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
